(() => {
  const TAG = 'bp-socks-discount';
  const CODE = 'FREESOCKS';
  if (customElements.get(TAG)) return;
  const normalize = value => String(value || '').trim().toUpperCase();
  let locked = false;

  // Prevent checkout while this component is adding or removing a gift.
  document.addEventListener('submit', event => {
    if (locked && event.target.matches('form[action*="/cart"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    if (locked && event.target.closest('[name="checkout"], a[href*="/checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  class SocksDiscount extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-code]');
      this.picker = this.querySelector('[data-picker]');
      this.color = this.querySelector('[data-color]');
      this.size = this.querySelector('[data-size]');
      this.status = this.querySelector('[data-status]');
      this.templates = [...this.querySelectorAll('template[data-sock-product]')];
      this.ids = new Set(this.templates.map(t => Number(t.dataset.sockProduct)));
      this.querySelector('[data-apply]').addEventListener('click', () => this.apply());
      this.querySelector('[data-add]').addEventListener('click', () => this.add());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          this.apply();
        }
      });
      this.input.addEventListener('input', () => {
        this.picker.hidden = true;
        this.message('');
      });
      this.color.addEventListener('change', () => {
        const template = this.templates.find(t => t.dataset.sockProduct === this.color.value);
        this.size.replaceChildren();
        if (template) this.size.append(template.content.cloneNode(true));
        this.size.disabled = !template;
        this.querySelector('[data-add]').disabled = true;
      });
      this.size.addEventListener('change', () => {
        this.querySelector('[data-add]').disabled = !this.size.value;
      });
    }

    message(text, isError = false) {
      this.status.textContent = text;
      this.status.dataset.error = String(isError);
    }
    async checkOffer(cart) {
      const variants = this.templates.flatMap(template =>
        [...template.content.querySelectorAll('option')]
          .filter(option => option.value && !option.disabled)
          .map(option => Number(option.value))
      );
      if (!variants.length) throw new Error('Die Socken sind momentan ausverkauft.');
      if (cart.items.length > 90) throw new Error('Dieser Warenkorb kann hier nicht geprüft werden. Bitte kontaktiere uns.');

      const lines = cart.items.map(item => {
        const line = {
          merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`,
          quantity: item.quantity,
          attributes: Object.entries(item.properties || {})
            .filter(([,value]) => value !== null && value !== '')
            .map(([key,value]) => ({ key, value: String(value) }))
        };
        if (item.selling_plan_allocation?.selling_plan?.id) {
          line.sellingPlanId = `gid://shopify/SellingPlan/${item.selling_plan_allocation.selling_plan.id}`;
        }
        return line;
      });
      lines.push({
        merchandiseId: `gid://shopify/ProductVariant/${variants[0]}`,
        quantity: 1,
        attributes: [{key: '_bp_offer_check', value: 'true'}]
      });
      const country = this.dataset.country || 'DE';
      const query = `mutation CheckSocksOffer($input: CartInput!, $country: CountryCode!)
        @inContext(country: $country) {
        cartCreate(input: $input) {
          cart {
            discountCodes { code applicable }
            lines(first: 100) {
              nodes {
                quantity
                attributes { key value }
                cost { totalAmount { amount } }
              }
            }
          }
          userErrors { message }
          warnings { message }
        }
      }`;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      let response, payload;
      try {
        response = await fetch(
          `https://${this.dataset.shopDomain}/api/2026-10/graphql.json`,
          {
            method: 'POST', credentials: 'omit',
            headers: {'Content-Type': 'application/json'},
            signal: controller.signal,
            body: JSON.stringify({ query, variables: {
              country,
              input: {
                buyerIdentity: {countryCode: country},
                lines,
                discountCodes: [...new Set([...this.codes(cart), CODE])],
                attributes: [{key: '_bp_validation_only', value: 'true'}]
              }
            }})
          }
        );
        payload = await response.json();
      } catch (error) {
        throw new Error('Die Aktion kann gerade nicht geprüft werden. Bitte versuche es erneut.');
      } finally { clearTimeout(timer); }
      const result = payload.data?.cartCreate;
     if (
  !response.ok ||
  payload.errors?.length ||
  !result?.cart ||
  result.userErrors?.length
) {
  console.warn(
    'FREESOCKS: Shopify-Prüfantwort',
    JSON.stringify({
      httpStatus: response.status,
      response: payload
    }, null, 2)
  );

  throw new Error(
    'Die Aktion kann gerade nicht geprüft werden. ' +
    'Bitte versuche es erneut.'
  );
}
      const probe = result.cart.lines.nodes.find(line =>
        line.attributes.some(a => a.key === '_bp_offer_check' && a.value === 'true')
      );
      if (!probe || probe.quantity !== 1) {
        throw new Error('Die Socken sind momentan nicht verfügbar.');
      }
      return result.cart.discountCodes.some(discount =>
        normalize(discount.code) === CODE && discount.applicable === true
      ) && Number(probe.cost.totalAmount.amount) === 0;
    }
    root() { return window.Shopify.routes.root; }
    async request(path, body) {
      const response = await fetch(this.root() + path, body === undefined ? {
        cache: 'no-store'
      } : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Shopify konnte die Anfrage nicht ausführen.');
      return data;
    }
    codes(cart) {
      return (cart.discount_codes || []).map(d => d.code).filter(Boolean);
    }
    accepted(cart, code) {
      return (cart.discount_codes || []).some(d => normalize(d.code) === normalize(code) && d.applicable === true);
    }
    async discount(cart, code) {
      const codes = [...new Set([...this.codes(cart).filter(c => normalize(c) !== normalize(code)), code])];
      return this.request('cart/update.js', { discount: codes.join(',') });
    }
    async publish() {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true, detail: { sections }
      }));
      const body = { updates: {} };
      if (sections.length) {
        body.sections = [...new Set(sections)].slice(0, 5).join(',');
        body.sections_url = window.location.pathname;
      }
      const result = await this.request('cart/update.js', body);
      const cart = await this.request('cart.js');
      cart.sections = result.sections || {};
      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: { baseEvent: 'bp-socks-discount', cart }
      }));
    }
    async run(task) {
      if (locked) return;
      locked = true;
      const states = [...this.querySelectorAll('input, select, button')].map(el => [el, el.disabled]);
      states.forEach(([el]) => { el.disabled = true; });
      this.setAttribute('aria-busy', 'true');
      try { await task(); }
      catch (error) { this.message(error.message || 'Bitte versuche es erneut.', true); }
      finally {
        locked = false;
        states.forEach(([el, disabled]) => { el.disabled = disabled; });
        this.removeAttribute('aria-busy');
      }
    }
    async apply() {
      const code = this.input.value.trim();
      if (!code || locked) return;
      if (normalize(code) === CODE) {
        this.picker.hidden = true;
        await this.run(async () => {
          this.message('Code wird geprüft …');
          const cart = await this.request('cart.js');
          if (cart.items.some(item => this.ids.has(Number(item.product_id)))) {
            this.message('Cream- oder Anthracite-Socken liegen bereits im Warenkorb. Bitte entferne sie zuerst, bevor du das Geschenk hier auswählst.', true);
            return;
          }
          if (!cart.items.some(item => !this.ids.has(Number(item.product_id)) && item.final_line_price > 0)) {
            this.message('Bitte zuerst mindestens einen anderen kostenpflichtigen Artikel hinzufügen.', true);
            return;
          }
          const valid = await this.checkOffer(cart);
          if (!valid) {
            this.message('Das gesamte Gratis-Socken-Kontingent ist leider aufgebraucht. Die Aktion ist beendet.', true);
            return;
          }
          this.picker.hidden = false;
          this.message('Bitte Farbe und Größe auswählen.');
        });
        if (!this.picker.hidden) this.color.focus();
        return;
      }
      this.picker.hidden = true;
      await this.run(async () => {
        this.message('Rabatt wird geprüft …');
        const before = await this.request('cart.js');
        const cart = await this.discount(before, code);
        if (!this.accepted(cart, code)) {
          await this.request('cart/update.js', { discount: this.codes(before).join(',') });
          this.message('Der Code ist für diesen Warenkorb aktuell nicht anwendbar.');
          return;
        }
        this.message('Rabatt angewendet.');
        await this.publish();
      });
    }
    async add() {
      if (normalize(this.input.value) !== CODE || !this.color.value || !this.size.value || locked) return;
      const variant = Number(this.size.value);
      const template = this.templates.find(t => t.dataset.sockProduct === this.color.value);
      const option = template && [...template.content.querySelectorAll('option')].find(o => Number(o.value) === variant);
      if (!option || option.disabled) return;
      await this.run(async () => {
        this.message('Socken und Rabatt werden geprüft. Bitte kurz warten …');
        const before = await this.request('cart.js');
        const socks = before.items.filter(item => this.ids.has(Number(item.product_id)));
        if (socks.length) {
          this.message('Cream- oder Anthracite-Socken liegen bereits im Warenkorb. Bitte prüfe sie dort und entferne sie zuerst, bevor du das Geschenk hier auswählst.');
          return;
        }
        if (!before.items.some(item => !this.ids.has(Number(item.product_id)) && item.final_line_price > 0)) {
          this.message('Bitte zuerst mindestens einen anderen kostenpflichtigen Artikel hinzufügen.');
          return;
        }
        const marker = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
        let accepted = false;
        try {
          await this.request('cart/add.js', { items: [{
            id: variant, quantity: 1,
            properties: { _bp_socks_gift: marker }
          }] });
          const current = await this.request('cart.js');
          const updated = await this.discount(current, CODE);
          const gift = updated.items.find(item => item.properties?._bp_socks_gift === marker);
          accepted = this.accepted(updated, CODE) && !!gift && gift.quantity === 1 && gift.final_line_price === 0;
          if (!accepted) throw new Error('Das Geschenk ist aktuell nicht verfügbar oder der Rabatt ist für diesen Warenkorb nicht gültig.');
        } catch (error) {
          // Only remove the line created by this attempt, never a purchased pair.
          try {
            const current = await this.request('cart.js');
            const gift = current.items.find(item => item.properties?._bp_socks_gift === marker);
            if (gift) await this.request('cart/change.js', { id: gift.key, quantity: 0 });
            await this.request('cart/update.js', { discount: this.codes(before).join(',') });
          } catch (cleanupError) {
            this.message('Die Prüfung konnte nicht abgeschlossen werden. Bitte lade die Seite neu und prüfe die Socken im Warenkorb vor dem Bezahlen.');
            return;
          }
          this.message(error.message, true);
          // The cart is back to its previous state; keep this explanation visible.
          return;
        }
        if (accepted) {
          this.message('Ein Paar Socken wurde kostenlos hinzugefügt.');
          try { await this.publish(); }
          catch (error) {
            this.message('Die Socken wurden hinzugefügt. Bitte lade die Seite neu, damit der aktuelle Warenkorb angezeigt wird.');
          }
        }
      });
    }
  }
  if (!customElements.get(TAG)) customElements.define(TAG, SocksDiscount);
})();
